/**
 * Header key constants for setting per-request audit context.
 *
 * Services can pass these as headers through the existing `headers`
 * parameter in GlobalDataStore / ApiDataService. The AuditContextInterceptor
 * will read them, combine them with the automatically-injected
 * `centre_location_id`, produce a single `audit-context` JSON header, and
 * strip the temporary `x-audit-*` headers before the request is sent.
 *
 * ### Usage in feature services
 *
 * ```ts
 * import { AUDIT_COMPONENT_NAME, AUDIT_DETAILS } from 'src/app/core/interceptors/audit-context';
 *
 * // When calling GlobalDataStore methods that accept headers:
 * this.splitBillingService.createRecord(data, [], {
 *   [AUDIT_COMPONENT_NAME]: 'SplitBillingComponent',
 *   [AUDIT_DETAILS]: 'Creating billing contact for child',
 * });
 * ```
 *
 * The `centre_location_id` is always included automatically — no need to
 * set it per-request.
 */
export const AUDIT_COMPONENT_NAME = 'x-audit-component-name';
export const AUDIT_DETAILS = 'x-audit-details';
